import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Storage from '@outdoor-voices/ui/dist/utils/Storage';
import OVIDClient from './OVIDClient';
import { wishListsQuery } from '../pages/wish-lists/queries';

var WishListCache = /*#__PURE__*/_createClass(function WishListCache() {
  var _this = this;

  _classCallCheck(this, WishListCache);

  _defineProperty(this, "cacheKey", 'ov-wish-lists');

  _defineProperty(this, "empty", {
    colorways: {},
    loaded: false,
    lists: {}
  });

  _defineProperty(this, "storage", new Storage());

  _defineProperty(this, "cache", function (data) {
    var cache = _objectSpread(_objectSpread({}, _this.empty), {}, {
      loaded: true
    });

    if (!data) {
      _this.storage.set(_this.cacheKey, JSON.stringify(cache));

      return;
    }

    var wishLists = data.wishLists;
    wishLists.forEach(function (_ref) {
      var id = _ref.id,
          items = _ref.items;
      var cachedItems = [];
      items.forEach(function (_ref2) {
        var emsColorwayGid = _ref2.emsColorwayGid,
            id = _ref2.id;
        cache.colorways[emsColorwayGid] = id;
        cachedItems.push({
          emsColorwayGid: emsColorwayGid,
          id: id
        });
      });
      cache.lists[id] = {
        id: id,
        items: cachedItems
      };
    });

    _this.storage.set(_this.cacheKey, JSON.stringify(cache));
  });

  _defineProperty(this, "clear", function () {
    _this.storage.remove(_this.cacheKey);
  });

  _defineProperty(this, "get", function () {
    var cache = _this.storage.get(_this.cacheKey);

    if (cache) {
      try {
        return JSON.parse(cache);
      } catch (_unused) {
        // Something is wrong with the cache, so wipe it out.
        _this.clear();

        return _this.empty;
      }
    }

    return _this.empty;
  });

  _defineProperty(this, "load", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ovIDClient, response, cache;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ovIDClient = new OVIDClient();
            _context.next = 3;
            return ovIDClient.query(wishListsQuery);

          case 3:
            response = _context.sent;
            cache = new WishListCache();
            cache.cache(response.data);
            return _context.abrupt("return", response.data);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));

  _defineProperty(this, "update", function (newWishList) {
    var _this$get = _this.get(),
        lists = _this$get.lists;

    var wishLists = [];
    lists[newWishList.id] = newWishList;
    Object.keys(lists).forEach(function (key) {
      wishLists.push(lists[key]);
    });

    _this.cache({
      wishLists: wishLists
    });
  });
});

export default WishListCache;